import React, { useEffect, useState } from 'react'
import api from '../services/api'
import AdminMenu from '../components/AdminMenu'; // ajusta la ruta si estás en una subcarpeta


function AdminMedallas() {
  const [medallas, setMedallas] = useState([])

  useEffect(() => {
    api.get('/medallas')
      .then(res => setMedallas(res.data))
      .catch(err => console.error('Error al cargar medallas', err))
  }, [])

  return (
    <div>
      <h2>Medallas del Sistema</h2>
      <ul>
        {medallas.map(m => (
          <li key={m.id}>
            <strong>{m.nombre}</strong> - {m.descripcion} ({m.puntos_requeridos} pts)
          </li>
        ))}
      </ul>
    </div>
  )
}

export default AdminMedallas
